<template>
  <div ref="voxelViewerDiv" v-loading="rending" :element-loading-text="$t('i.rendin')" shadow="never" element-loading-background="rgba(0, 0, 0, 0.6)" :style="voxelStyle" />
</template>
<script>
import { mixins } from '@/mixins/common'
import utils from '@/js/utils'
import service from '@/js/service'
import conf from '@/js/conf/conf'
import GRIDY from '@/js/sdk/GridySDK'
import download from 'downloadjs'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { DragControls } from 'three/examples/jsm/controls/DragControls.js'
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { VOXLoader, VOXMesh } from '@/js/three/VOXLoader.js'
import { CHAINMesh } from '@/js/three/CHAINLoader.js'
import { BLOCKMesh } from '@/js/three/BLOCKLoader.js'
import { BLKMesh } from '@/js/three/BLKLoader.js'
/* eslint-disable */
export default {
  mixins: [mixins],
  props: {
    width: {
      type: Number,
      default() {
        return 300
      }
    },
    height: {
      type: Number,
      default() {
        return 300
      }
    },
    skyStyleid: {
      type: Number,
      default() {
        return 0
      }
    },
    fixpos: {
      type: Number,
      default() {
        return 0
      }
    },
    showLoding: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    voxelStyle() {
      const style = {
        width: this.width + 'px',
        height: this.height + 'px',
        overflow: 'hidden',
        background: '#1b1b1b',
        'text-align': 'center'
      }
      return style
    },
    cols() {
      return this.work.canvas ? this.work.canvas.cols : 0
    },
    rows() {
      return this.work.canvas ? this.work.canvas.rows : 0
    }
  },
  watch: {},
  data() {
    return {
      // 是否显示模型原色
      keepOrginColor: false,
      // 是否启用反照率模式
      albedo: false,
      rending: false,
      // 曝光度
      exposure: 60,
      // 0-100 控制灯光明暗，50为默认亮度
      lightValue: 60,
      lightValueMax: 60,
      lightValueMin: 40,
      // 灯光照射角度（方位角，0-360，绕Y轴旋转，度）
      lightAngel: 120,
      // 灯光仰角（0-90，0=水平，90=正上，度）
      lightElevation: 45
    }
  },
  mounted() {
    this.GRIDY = new GRIDY()
    this.inited = false
    // realVoxel false：贴图 true：体素模型
    // this.realVoxel = this.isDesktop
    this.realVoxel = false
    // 是否显示边框
    this.showcubeBorder = true
    const cdnHost = conf.hosts().cdnHost
    this.tshirtGlbs = [cdnHost + 'glb/tshirt_0.glb', cdnHost + 'glb/tshirt_1.glb']
    this.skyBoxTextures = [
      [
        cdnHost + 'sky/sky.jpg',
        cdnHost + 'sky/sky.jpg',
        cdnHost + 'sky/sky_back.png',
        cdnHost + 'sky/sky_back.png',
        cdnHost + 'sky/sky.jpg',
        cdnHost + 'sky/sky.jpg'
      ],
      [
        cdnHost + 'sky0/ft.jpg',
        cdnHost + 'sky0/bk.jpg',
        cdnHost + 'sky0/up.jpg',
        cdnHost + 'sky0/dn.jpg',
        cdnHost + 'sky0/rt.jpg',
        cdnHost + 'sky0/lf.jpg'
      ],
      [
        cdnHost + 'sky1/ft.jpg',
        cdnHost + 'sky1/bk.jpg',
        cdnHost + 'sky1/up.jpg',
        cdnHost + 'sky1/dn.jpg',
        cdnHost + 'sky1/rt.jpg',
        cdnHost + 'sky1/lf.jpg'
      ],
      [
        cdnHost + 'room/ft.jpg',
        cdnHost + 'room/bk.jpg',
        cdnHost + 'room/up.jpg',
        cdnHost + 'room/dn.jpg',
        cdnHost + 'room/rt.jpg',
        cdnHost + 'room/lf.jpg'
      ],
      [
        cdnHost + 'meadow/ft.jpg',
        cdnHost + 'meadow/bk.jpg',
        cdnHost + 'meadow/up.jpg',
        cdnHost + 'meadow/dn.jpg',
        cdnHost + 'meadow/rt.jpg',
        cdnHost + 'meadow/lf.jpg'
      ]
    ]
    this.skyBoxTextureIdx = 1
    this.paperNum = 0
    this.partCols = 0
    this.partRows = 0
    this.partWidth = 0
    this.wallId = ''
    this.frameId = 'whiteWhite'
    this.tshirtIdx = 0
    this.diySide = 0
    this.diyType = ''
    this.diyColor = '#FFFFFF'
    this.autoRotate = false
    this.autoRotateSpeed = -0.2
    this.interact = true
    this.work = {}
    this.canvasEl = null
    this.showBorder = true
    this.bgColor = 0x1b1b1b
    this.initThree = false
    this.maxSize = 64
    this.renderer = null
    this.camera = null
    this.scene = null
    this.light = null
    this.controls = null
    this.dragControls = null
    this.geometry = null
    this.transform = null
    this.merged = null
    this.mergeMesh = null
    this.materialRight = null
    this.materialLeft = null
    this.materialTop = null
    this.materialBottom = null
    this.materialFront = null
    this.materialBack = null
    this.group = null
    this.diy = null
    this.cubes = null
    this.cube = null
    this.box = null
    this.gridHelper = null
    this.showHelper = false
    this.boxEl = {}
    this.skyGeometry = null
    this.textureCube = null
    this.shader = null
    this.skyMaterial = null
    this.skybox = null
    this.cacheData = {}
    this.voxelChunks = []
    this.voxelMesh = null
    this.layerStats = null
    this.currentModel = null
    this.textureShow = true
    this.isAnimating = false
  },
  beforeDestroy() {
    this.GRIDY = null
    if (this.renderer) {
      this.renderer.dispose()
      this.renderer.renderLists.dispose()
      // 注释掉避免闪白屏
      // this.renderer.forceContextLoss()
      this.renderer.context = null
      this.container.removeChild(this.renderer.domElement)
      this.renderer.domElement = null
      this.renderer = null
    }
    this.inited = false
    this.showBorder = true
    this.bgColor = null
    this.initThree = false
    this.maxSize = 64
    this.camera = null
    this.scene = null
    this.light = null
    this.controls = null
    this.dragControls = null
    this.geometry = null
    this.transform = null
    this.merged = null
    this.mergeMesh = null
    this.materialRight = null
    this.materialLeft = null
    this.materialTop = null
    this.materialBottom = null
    this.materialFront = null
    this.materialBack = null
    this.group = this.diy = null
    if (this.cubes) this.cubes.clear()
    this.cubes = null
    this.cube = null
    this.box = null
    this.gridHelper = null
    this.showHelper = false
    this.boxEl = {}
    this.skyGeometry = null
    this.textureCube = null
    this.shader = null
    this.skyMaterial = null
    this.skybox = null
    this.cacheData = {}
    this.voxelChunks = []
    this.voxelMesh = null
    this.layerStats = null
    this.currentModel = null
    this.textureShow = true
    window.onresize = null
  },
  methods: {
    // 设置缓存数据
    setCacheData(data, cacheType = '') {
      cacheType = cacheType || this.diyType || 'default'
      this.cacheData[cacheType] = data || null
    },
    // 获取缓存数据
    getCacheData(cacheType = '') {
      cacheType = cacheType || this.diyType || 'default'
      return this.cacheData[cacheType] || null
    },
    setWork(work) {
      this.work = work
    },
    resetVoxelChunks() {
      this.voxelChunks = []
      this.work.voxelChunks = []
    },
    // 设置Diy模式 枚举值：'d3', 'vox', 'chain_brick', 'lego_brick', 'voxelPaper', 'tshirt', 'paper', 'originImage', 'gridy'
    setDiyMod(type, data = {}) {
      if (type === 'paper') this.realVoxel = false
      this.diyType = type
      if (typeof data.wallId !== 'undefined') this.wallId = data.wallId
      if (typeof data.showBorder !== 'undefined') this.showBorder = data.showBorder
      if (typeof data.frameId !== 'undefined') this.frameId = data.frameId
      if (typeof data.side !== 'undefined') this.diySide = data.side
      if (typeof data.color !== 'undefined') this.diyColor = data.color
      if (typeof data.tshirtIdx !== 'undefined') this.tshirtIdx = data.tshirtIdx
      if (typeof data.paperNum !== 'undefined') this.paperNum = data.paperNum
      if (typeof data.partCols !== 'undefined') this.partCols = data.partCols
      if (typeof data.partRows !== 'undefined') this.partRows = data.partRows
      if (typeof data.partWidth !== 'undefined') this.partWidth = data.partWidth
      if (typeof data.customType !== 'undefined') this.customType = data.customType
      if (typeof data.keepOrginColor !== 'undefined') this.keepOrginColor = data.keepOrginColor
      if (type === 'd3' || type === 'vox' || type === 'chain_brick' || type === 'lego_brick') {
        this.autoRotate = true
      } else {
        this.autoRotate = false
      }
    },
    borderToggle(showBorder) {
      this.showBorder = showBorder
    },
    setAutoRotate(autoRotate, speed) {
      this.autoRotate = autoRotate
      this.autoRotateSpeed = typeof speed !== 'undefined' ? speed : this.autoRotateSpeed
      if (this.controls) {
        this.controls.autoRotate = this.autoRotate
        this.controls.autoRotateSpeed = this.autoRotateSpeed
      }
    },
    saveSnapshot(size = 512) {
      const [snapshot, width, height] = this.getCurrentSnapshot(size)
      download(snapshot, this.work.name + '_' + size + '.png', 'image/png')
    },
    // 获取盒子模型
    getBox(id) {
      const el = this.$refs[id]
      if (el) {
        return el.getBoundingClientRect()
      } else {
        return { x: 0, y: 0, left: 0, top: 0, right: 0, bottom: 0, width: 0, height: 0 }
      }
    },
    getTexture(canvas, pos = 'back') {
      const canvasTmp = document.createElement('canvas')
      const ctx = canvasTmp.getContext('2d')
      if (pos === 'top') {
        canvasTmp.width = canvas.width
        canvasTmp.height = 1
        ctx.drawImage(canvas, 0, 8, canvasTmp.width, canvasTmp.height, 0, 0, canvasTmp.width, canvasTmp.height)
      } else if (pos === 'bottom') {
        canvasTmp.width = canvas.width
        canvasTmp.height = 1
        ctx.drawImage(canvas, 0, canvas.height - 8, canvasTmp.width, canvasTmp.height, 0, 0, canvasTmp.width, canvasTmp.height)
      } else if (pos === 'left') {
        canvasTmp.width = 1
        canvasTmp.height = canvas.height
        ctx.drawImage(canvas, 8, 0, canvasTmp.width, canvasTmp.height, 0, 0, canvasTmp.width, canvasTmp.height)
      } else if (pos === 'right') {
        canvasTmp.width = 1
        canvasTmp.height = canvas.height
        ctx.drawImage(canvas, canvas.width - 8, 0, canvasTmp.width, canvasTmp.height, 0, 0, canvasTmp.width, canvasTmp.height)
      } else if (pos === 'back') {
        canvasTmp.height = canvas.height
        canvasTmp.width = canvas.width
        ctx.translate(canvasTmp.width, 0)
        ctx.scale(-1, 1)
        ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height)
      }
      let texture
      if (pos === 'front') {
        if (this.diyType === 'paper') {
          // canvasTmp.width = this.partWidth
          // canvasTmp.height = this.partWidth
          // const x = (this.paperNum % this.partCols) * this.partWidth
          // const y = Math.floor(this.paperNum / this.partCols) * this.partWidth
          // ctx.drawImage(canvas, x, y, this.partWidth, this.partWidth, 0, 0, canvasTmp.width, canvasTmp.height)
          canvasTmp.width = this.partWidth + 64
          canvasTmp.height = this.partWidth + 64
          const x = (this.paperNum % this.partCols) * this.partWidth
          const y = Math.floor(this.paperNum / this.partCols) * this.partWidth
          ctx.fillStyle = '#FFFFFF'
          ctx.fillRect(0, 0, canvasTmp.width, canvasTmp.height)
          // 绘制标尺
          for (let c = 0; c <= 16; c++) {
            if (c % 2 === 0 && c) {
              this.GRIDY.drawLocalNum(ctx, c, 0, 32, '#000000', utils.padding(c, 2))
              this.GRIDY.drawLocalNum(ctx, c, 17, 32, '#000000', utils.padding(c, 2))
            }
          }
          for (let r = 0; r <= 16; r++) {
            if (r % 2 === 0 && r) {
              this.GRIDY.drawLocalNum(ctx, 0, r + 0, 32, '#000000', r ? utils.padding(r, 2) : r)
              this.GRIDY.drawLocalNum(ctx, 17, r + 0, 32, '#000000', r ? utils.padding(r, 2) : r)
            }
          }
          ctx.drawImage(canvas, x, y, this.partWidth, this.partWidth, 32, 32, this.partWidth, this.partWidth)
          texture = new THREE.CanvasTexture(canvasTmp)
        } else {
          texture = new THREE.CanvasTexture(canvas)
        }
      } else {
        texture = new THREE.CanvasTexture(canvasTmp)
      }
      texture.needUpdate = true
      return texture
    },
    // 获取T恤贴图
    getTshirtTexture(frontImage, backImage) {
      const textTureWidth = 320
      const textTureHeight = 480
      let frontSize = {}
      let backSize = {}
      if (frontImage) {
        frontSize = utils.calcImageSize(frontImage.width, frontImage.height, textTureWidth, textTureHeight)
      }
      if (backImage) {
        backSize = utils.calcImageSize(backImage.width, backImage.height, textTureWidth, textTureHeight)
      }
      const canv = document.createElement('canvas')
      canv.width = 3300
      canv.height = 3300
      const ctx = canv.getContext('2d')
      ctx.clearRect(0, 0, canv.width, canv.height)
      this.GRIDY.drawRect(ctx, 0, 0, canv.width, canv.height, this.diyColor)
      let frontFixX = 0
      let backFixX = 0
      if (this.tshirtIdx) {
        frontFixX = 70
        backFixX = 30
        if (frontImage) ctx.drawImage(frontImage, 1950 + frontFixX + (textTureWidth - frontSize.width) / 2, 1750 + (textTureHeight - frontSize.height) / 2, frontSize.width, frontSize.height)
        if (backImage) ctx.drawImage(backImage, 670 + backFixX + (textTureWidth - backSize.width) / 2, 1750 + (textTureHeight - backSize.height) / 2, backSize.width, backSize.height)
      } else {
        if (frontImage) ctx.drawImage(frontImage, 670 + frontFixX + (textTureWidth - frontSize.width) / 2, 1750 + (textTureHeight - frontSize.height) / 2, frontSize.width, frontSize.height)
        if (backImage) ctx.drawImage(backImage, 1950 + backFixX + (textTureWidth - backSize.width) / 2, 1750 + (textTureHeight - backSize.height) / 2, backSize.width, backSize.height)
      }
      const texture = new THREE.CanvasTexture(canv)
      texture.flipY = false
      texture.offset.x = 0.1
      texture.offset.y = 0.1
      texture.repeat.set(0.7, 0.7)
      return texture
    },
    // 加载并渲染T恤
    drawTshirt(frontImage, backImage) {
      const loader = new GLTFLoader()
      loader.load(this.tshirtGlbs[this.tshirtIdx], (gltf) => {
        const tshirt = gltf.scene
        tshirt.traverse((o) => {
          if (o.isMesh) {
            o.material.map = this.getTshirtTexture((this.diySide === 0 || this.diySide === 2) ? frontImage : '', (this.diySide === 1 || this.diySide === 2) ? backImage : '')
          }
        })
        this.diy.add(tshirt)
      })
      this.camera.position.set(0, 0, this.isDesktop ? 21 : 28)
    },
    loading(show) {
      if (!this.showLoding) return
      this.rending = show
    },
    // 获取体素模型BLOB
    getVOXFileBlob(cb) {
      return this.GRIDY.getVOXFileBlob(this.voxelChunks, this.diyType, cb)
    },
    // 下载体素模型
    downloadVOXFile(cb) {
      download(this.getVOXFileBlob(cb), this.work.name + '.vox', 'application/octet-stream')
    },
    destroyCurrentModel() {
      if (this.currentModel) {
        this.scene.remove(this.currentModel)
        this.currentModel = null
      }
    },
    calcVoxelColors() {
      this.GRIDY.setVoxelChunks(this.voxelChunks)
      return this.GRIDY.calcVoxelColors(0)
    },
    destroyVoxelChunks() {
      this.voxelChunks = []
      this.work.voxelChunks = []
    },
    // 获取当前渲染画面的截图（不调整相机位置）
    getCurrentSnapshot(targetSize = 512) {
      if (!this.renderer || !this.camera) return ['', targetSize, targetSize]
      
      // 记录当前状态
      const canvas = this.renderer.domElement
      const prevW = canvas.width
      const prevH = canvas.height
      const prevPR = this.renderer.getPixelRatio()
      const prevAspect = this.camera.aspect
      
      // 计算目标尺寸（保持宽高比或使用正方形）
      let targetWidth = targetSize
      let targetHeight = targetSize
      if (prevW > 0 && prevH > 0) {
        const aspect = prevW / prevH
        if (aspect > 1) {
          // 横向
          targetWidth = targetSize
          targetHeight = Math.round(targetSize / aspect)
        } else {
          // 纵向或正方形
          targetWidth = Math.round(targetSize * aspect)
          targetHeight = targetSize
        }
      }
      
      // 临时调整渲染器尺寸和相机参数
      this.camera.aspect = targetWidth / targetHeight
      this.camera.updateProjectionMatrix()
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2))
      this.renderer.setSize(targetWidth, targetHeight, false)
      
      // 渲染并截图
      this.render()
      const dataUrl = this.renderer.domElement.toDataURL('image/png')
      
      // 恢复原始状态
      this.camera.aspect = prevAspect
      this.camera.updateProjectionMatrix()
      this.renderer.setPixelRatio(prevPR)
      this.renderer.setSize(prevW, prevH, false)
      
      return [dataUrl, targetWidth, targetHeight]
    },
    // 获取截图：透明背景
    getSnapshot(targetSize = 512) {
      if (!this.renderer || !this.camera || !this.currentModel) return ''
      const occupy = 0.6

      // 2) 记录旧状态
      const canvas = this.renderer.domElement
      const prevW = canvas.width
      const prevH = canvas.height
      const prevPR = this.renderer.getPixelRatio()
      const prevAspect = this.camera.aspect
      const prevPos = this.camera.position.clone()
      const prevQuat = this.camera.quaternion.clone()
      const hadSky = !!this.skybox
      
      // 记录渲染器状态
      const prevClearColor = new THREE.Color()
      this.renderer.getClearColor(prevClearColor)
      const prevClearAlpha = this.renderer.getClearAlpha()
      const prevBackground = this.scene.background

      // 3) 计算模型包围盒及中心
      const box = new THREE.Box3().setFromObject(this.currentModel)
      const center = box.getCenter(new THREE.Vector3())
      const size = box.getSize(new THREE.Vector3())
      const maxDim = Math.max(size.x, size.y, size.z)

      // 4) 计算所需距离，使模型占屏幕高度的60%
      const fov = this.camera.fov * (Math.PI / 180)
      const distance = maxDim / (occupy * 2 * Math.tan(fov / 2))

      // 5) 将相机放到右上方位置，指向模型中心
      const azimuth = Math.PI / 4
      const elevation = Math.PI / 3
      // 使用球面坐标计算相机位置
      const x = center.x + distance * Math.cos(elevation) * Math.cos(azimuth)
      const y = center.y + distance * Math.cos(elevation) * Math.sin(azimuth)
      const z = center.z + distance * Math.sin(elevation)
      const newPos = new THREE.Vector3(x, y, z)
      // 6) 调整渲染与相机参数
      if (hadSky) this.scene.remove(this.skybox)
      
      // 设置透明背景
      this.scene.background = null
      this.renderer.setClearColor(0x000000, 0) // 透明背景
      this.renderer.setClearAlpha(0) // 完全透明
      
      this.camera.aspect = 1
      this.camera.position.copy(newPos)
      this.camera.lookAt(center)
      this.camera.updateProjectionMatrix()
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2))
      this.renderer.setSize(targetSize, targetSize, false)

      // 7) 渲染并截图
      this.render()
      const dataUrl = this.renderer.domElement.toDataURL('image/png')
      // 8) 恢复状态
      this.camera.aspect = prevAspect
      this.camera.position.copy(prevPos)
      this.camera.quaternion.copy(prevQuat)
      this.camera.updateProjectionMatrix()
      this.renderer.setPixelRatio(prevPR)
      this.renderer.setSize(prevW, prevH, false)
      
      // 恢复渲染器状态
      this.renderer.setClearColor(prevClearColor, prevClearAlpha)
      this.scene.background = prevBackground
      if (hadSky) this.scene.add(this.skybox)

      return [dataUrl, targetSize, targetSize]
    },
    // 加载体素模型
    loadVox(url, type = 'vox', cb, useCachedChunks = true) {
      if (!this.inited) {
        this.loading(false)
        cb && cb()
        return Promise.reject('3D viewer not initialized')
      }
      // console.error('voxelViewer loadVox00000000000000000000', url, type, this.work, this.work.opts, useCachedChunks)
      // 关闭暗色匹配
      // this.work.opts.darkMatch = false
      const workType = (this.work && this.work.data && this.work.data.type) ? this.work.data.type : 'vox'
      const renderChunks = (originalChunks) => {
        const chunks = []
        originalChunks.forEach(chunk => {
          chunks.push({data: [...chunk.data], size: {x: chunk.size.x, y: chunk.size.y, z: chunk.size.z}, palette: [...chunk.palette]})
        })
        let voxelChunks = []
        let chunk = null
        // 如果当前是图纸，并且有缓存数据，则使用缓存数据
        const cacheChunk = this.getCacheData('voxelPaperChunk')
        if (this.diyType === 'voxelPaper' && cacheChunk) {
          chunk = {data: [...cacheChunk.data], size: {x: cacheChunk.size.x, y: cacheChunk.size.y, z: cacheChunk.size.z}, palette: [...cacheChunk.palette]}
        } else {
          chunk = chunks[0]
          chunk = this.GRIDY.trimVoxels(chunk)
          chunk = this.GRIDY.getShellVoxels(chunk)
          chunk = this.GRIDY.setChunkPalette(chunk, this.work.opts)
          if (this.work.opts && this.work.opts.layerDenoiseValue) {
            // 层降噪
            chunk = this.GRIDY.layerDenoise(chunk, this.work.opts.layerDenoiseValue)
          }
          if (this.work.opts && this.work.opts.replaceColors && Object.keys(this.work.opts.replaceColors).length > 0) {
            chunk = this.GRIDY.replaceChunkColors(chunk, this.work.opts.replaceColors)
          }
          chunk = this.GRIDY.addHelpVoxels(chunk)
          // 如果当前是图纸，则添加辅助体素；非图纸模式，则不添加辅助体素
          // if (this.diyType === 'voxelPaper') chunk = this.GRIDY.addHelpVoxels(chunk)
        }
        const x = Math.max(0, chunk.size.x)
        const y = Math.max(0, chunk.size.y)
        const z = Math.max(0, chunk.size.z)
        if (this.diyType === 'voxelPaper') {
          // 如果当前是图纸，则缓存数据
          this.setCacheData(chunk, 'voxelPaperChunk')
          if (!this.keepOrginColor && this.paperNum > 0 && this.paperNum < chunk.size.z) {
            chunk = this.GRIDY.getLayerChunk(chunk, this.paperNum)
          }
        }
        voxelChunks.push(chunk)
        this.destroyCurrentModel()
        if (this.diyType === 'voxelPaper') {
          const currentZ = !this.keepOrginColor ? chunk.size.z - 1 : this.paperNum;
          if ( workType === 'chain_brick') {
            this.currentModel = new CHAINMesh(chunk, currentZ, 'natural', 'chain', null, 1, false, this.keepOrginColor)
          } else if (workType === 'lego_brick') {
            this.currentModel = new BLOCKMesh(chunk, currentZ, 'natural', 'block', null, 0, false, this.keepOrginColor)
          } else {
            this.currentModel = new BLKMesh(chunk, currentZ, 'natural', 'blk01', null, 2, false, this.keepOrginColor)
          }
          this.layerStats = this.currentModel.getLayerPartStats(currentZ);
          // TODO: 显示颗粒统计信息
          this.currentModel.scale.setScalar(this.isDesktop ? (chunk.size.z > 32 ? 0.1 : 0.35) : (chunk.size.z > 32 ? 0.35 : 0.45))
        } else {
          this.currentModel = new VOXMesh(chunk, type, 'natural')
          this.currentModel.scale.setScalar(this.isDesktop ? 1.2 : 0.8)
        }
        this.scene.add(this.currentModel)
        this.work.width = x
        this.work.height = y
        this.work.depth = z
        this.voxelChunks = voxelChunks
        this.work.voxelChunks = voxelChunks
        this.GRIDY.setFile(this.work)
        this.fitCameraToModel()
        // 如果启用了反照率模式，应用反照率材质
        if (this.albedo) {
          this.setAlbedo(true)
        }
        cb && cb(this.work)
        this.loading(false)
      }
      if (this.voxelChunks && this.voxelChunks.length > 0 && useCachedChunks) {
        renderChunks(this.voxelChunks)
        return
      }
      // 如果有原始体素数据，则使用原始体素数据 避免重复加载
      if (this.getCacheData()) {
        renderChunks(this.getCacheData())
        return
      }
      const loader = new VOXLoader()
      let objectUrl = null
      const src = (url instanceof File || url instanceof Blob) ? (objectUrl = URL.createObjectURL(url)) : url
      loader.load(src, (chunks) => {
        if (objectUrl) URL.revokeObjectURL(objectUrl)
        this.setCacheData(chunks)
        renderChunks(chunks)
      }, (progress) => {
        // console.log('Loading progress:', (progress.loaded / progress.total * 100) + '%')
      }, (error) => {
        if (objectUrl) URL.revokeObjectURL(objectUrl)
        this.loading(false)
        cb && cb()
        return Promise.reject(error)
      })
    },
    // URL https://coscdn.gridy.art/public/paint/000/00/00/01/10272_0.GLB?1761912677
    // 加载3D模型
    loadD3(url, cb) {
      if (!this.inited) {
        this.loading(false)
        cb && cb()
        return Promise.reject('3D viewer not initialized')
      }
      // if (typeof url === 'string') {
      //   // 这里不用CDN地址，因为3D文件暂时不对外开放，无需CDN加速
      //   url = service.getRawCosUrl(url)
      // }
      return new Promise((resolve, reject) => {
        // 清除当前模型
        this.destroyCurrentModel()
        // 如果有原始3D模型，则使用原始3D模型 避免重复加载
        if (this.getCacheData()) {
          this.currentModel = this.getCacheData()
          this.scene.add(this.currentModel)
          this.fitCameraToModel()
          // 如果启用了反照率模式，应用反照率材质
          if (this.albedo) {
            this.setAlbedo(true)
          }
          this.loading(false)
          cb && cb()
          return
        }
        const loader = new GLTFLoader()
        let objectUrl = null
        const src = (url instanceof File || url instanceof Blob) ? (objectUrl = URL.createObjectURL(url)) : url
        loader.load(
          src,
          (gltf) => {
            if (objectUrl) URL.revokeObjectURL(objectUrl)
            this.setCacheData(gltf.scene)
            this.currentModel = gltf.scene
            this.scene.add(this.currentModel)
            // 自动调整相机位置
            this.fitCameraToModel()
            // 如果启用了反照率模式，应用反照率材质
            if (this.albedo) {
              this.setAlbedo(true)
            }
            resolve(gltf)
            this.loading(false)
            cb && cb()
          },
          (progress) => {
            // console.log('Loading progress:', (progress.loaded / progress.total * 100) + '%')
          },
          (error) => {
            if (objectUrl) URL.revokeObjectURL(objectUrl)
            this.loading(false)
            reject(error)
            cb && cb()
          }
        )
      })
    },
    
    // 调整相机位置以适应模型
    fitCameraToModel() {
      if (!this.currentModel) return
      if (this.diyType === 'voxelPaper') {
        if (this.isDesktop) {
          this.camera.position.set(-6, 8, 10)
        } else {
          this.camera.position.set(-26, 28, 10)
        }
        const box = new THREE.Box3().setFromObject(this.currentModel)
        const center = box.getCenter(new THREE.Vector3())
        this.camera.lookAt(center)
        this.controls.target.copy(center)
        this.controls.minDistance = 0.3
        this.controls.update()
        return
      }
      const box = new THREE.Box3().setFromObject(this.currentModel)
      const center = box.getCenter(new THREE.Vector3())
      const size = box.getSize(new THREE.Vector3())
      const maxDim = Math.max(size.x, size.y, size.z)
      const fov = this.camera.fov * (Math.PI / 180)
      let cameraZ = Math.abs(maxDim / 2 / Math.tan(fov / 2))
      // 边距缩小，默认更贴近模型显示更大
      if (this.isDesktop) {
        cameraZ *= 2
      } else {
        cameraZ *= 3
      }
      this.camera.position.set(center.x, center.y, center.z + cameraZ)
      // 允许更近距离缩放，便于放大更多
      this.controls.minDistance = 1
      this.camera.lookAt(center)
      this.controls.target.copy(center)
      this.controls.update()
    },
    drawIt(canvas, cb, useCachedChunks = true) {
      canvas = canvas || this.canvasEl
      if (!canvas) return
      const frameDt = conf.frameDt()
      let frameConf = {}
      if (this.diyType === 'brick') {
        frameConf = frameDt[this.frameId] ? utils.deepClone(frameDt[this.frameId]) : {}
        if (frameConf.border) frameConf.border = eval(frameConf.border.replace('#', '0x'))
        if (frameConf.shadow) frameConf.shadow = eval(frameConf.shadow.replace('#', '0x'))
      }
      if (this.cubes) this.cubes.clear()
      if (this.diy) this.diy.clear()
      this.destroyCurrentModel()
      if (this.diyType === 'tshirt') {
        this.drawTshirt(canvas, canvas)
        cb && cb()
      } else if (this.diyType === 'd3' || this.diyType === 'vox' || this.diyType === 'chain_brick' || this.diyType === 'lego_brick' || this.diyType === 'voxelPaper') {
        this.loading(true)
        let src = this.work.fileObj || (this.work.data && this.work.data.url)
        if (!(src instanceof File) && !(src instanceof Blob)) {
          src = service.getCosUrl(src, 'paint', this.work.public_at, false, false)
        }
        if (this.diyType === 'd3') {
          this.loadD3(src, cb)
        } else {
          this.loadVox(src, this.diyType, cb, this.diyType === 'voxelPaper' ? false : useCachedChunks)
        }
      } else {
        // const texture = new THREE.CanvasTexture(canvas)
        // texture.needUpdate = true
        this.materialFront = new THREE.MeshBasicMaterial({ color: 0xeeeeee, map: this.getTexture(canvas, 'front'), transparent: this.diyType !== 'brick' && this.diyType !== 'paper' })
        if (this.diyType === 'brick'|| this.diyType === 'paper') {
          this.materialBack = new THREE.MeshBasicMaterial({ color: frameConf.shadow || 0xeaeaea })
        } else {
          this.materialBack = new THREE.MeshBasicMaterial({ color: frameConf.border || 0xeeeeee, map: this.getTexture(canvas, 'back'), transparent: true })
        }
        if (this.diyType === 'paper') {
          this.materialBottom = new THREE.MeshBasicMaterial({ color: 0xdddddd })
          this.materialTop = new THREE.MeshBasicMaterial({ color: 0xdddddd })
          this.materialLeft = new THREE.MeshBasicMaterial({ color: 0xdddddd })
          this.materialRight = new THREE.MeshBasicMaterial({ color: 0xdddddd })
        } else {
          this.materialBottom = new THREE.MeshBasicMaterial({ color: frameConf.border || 0xeeeeee, map: this.getTexture(canvas, 'bottom'), transparent: true })
          this.materialTop = new THREE.MeshBasicMaterial({ color: frameConf.border || 0xeeeeee, map: this.getTexture(canvas, 'top'), transparent: true })
          this.materialLeft = new THREE.MeshBasicMaterial({ color: frameConf.border || 0xeeeeee, map: this.getTexture(canvas, 'left'), transparent: true })
          this.materialRight = new THREE.MeshBasicMaterial({ color: frameConf.border || 0xeeeeee, map: this.getTexture(canvas, 'right'), transparent: true })
        }
        let width, height
        if (this.diyType === 'paper') {
          width = this.work.canvas.rows
          height = this.work.canvas.rows
        } else if (this.diyType === 'originImage' || this.diyType === 'gridy') {
          width = this.work.canvas.cols
          height = this.work.canvas.rows
        } else {
          width = canvas.width / 16
          height = canvas.height / 16
        }
        this.maxSize = Math.max(width, height)
        let deps = Math.max(this.maxSize / 50, 1)
        // console.error('this.diyType', this.diyType, this.showBorder, this.customType)
        if (this.diyType === 'brick' && this.showBorder && this.customType !== 'customBeads' && this.customType !== 'printD3') {
          deps = 1
          const borderSize = 1
          // 渲染拼图边框
          const materialBorder = new THREE.MeshBasicMaterial({ color: frameConf.border || 0xeeeeee })
          const materialBorder2 = new THREE.MeshBasicMaterial({ color: frameConf.shadow || 0xeaeaea })
          const borderTopBox = new THREE.BoxGeometry(canvas.width / 16 + borderSize * 2, borderSize, deps * 2)
          const borderTopMesh = new THREE.Mesh(borderTopBox, [materialBorder, materialBorder, materialBorder, materialBorder2, materialBorder, materialBorder])
          borderTopMesh.position.set(0, height / 2 + borderSize / 2, 0.5)
          const borderBottomBox = new THREE.BoxGeometry(canvas.width / 16 + borderSize * 2, borderSize, deps * 2)
          const borderBottomMesh = new THREE.Mesh(borderBottomBox, [materialBorder, materialBorder, materialBorder2, materialBorder, materialBorder, materialBorder])
          borderBottomMesh.position.set(0, -height / 2 - borderSize / 2, 0.5)
          const borderLeftBox = new THREE.BoxGeometry(borderSize, canvas.height / 16, deps * 2)
          const borderLeftMesh = new THREE.Mesh(borderLeftBox, [materialBorder, materialBorder2, materialBorder, materialBorder, materialBorder, materialBorder])
          borderLeftMesh.position.set(width / 2 + borderSize / 2, 0, 0.5)
          const borderRightBox = new THREE.BoxGeometry(borderSize, canvas.height / 16, deps * 2)
          const borderRightMesh = new THREE.Mesh(borderRightBox, [materialBorder2, materialBorder, materialBorder, materialBorder, materialBorder, materialBorder])
          borderRightMesh.position.set(-width / 2 - borderSize / 2, 0, 0.5)
          if (this.cubes && frameConf.border) this.cubes.add(borderTopMesh)
          if (this.cubes && frameConf.border) this.cubes.add(borderBottomMesh)
          if (this.cubes && frameConf.border) this.cubes.add(borderLeftMesh)
          if (this.cubes && frameConf.border) this.cubes.add(borderRightMesh)
        } else if (this.diyType === 'paper') {
          deps = 0.1
        }
        this.box = new THREE.BoxGeometry(width, height, deps)
        this.cube = new THREE.Mesh(this.box, [this.materialRight, this.materialLeft, this.materialTop, this.materialBottom, this.materialFront, this.materialBack])
        if (this.showcubeBorder && this.diyType !== 'brick') {
          // 几何体box作为EdgesGeometry参数创建一个新的几何体
          var edges = new THREE.EdgesGeometry(this.box)
          // 线框，不显示中间的斜线
          var edgesMaterial = new THREE.LineBasicMaterial({ color: 0x1E90FF, transparent: true, opacity: 0.2 })
          var line = new THREE.LineSegments(edges,edgesMaterial)
          if (this.cubes) this.cubes.add(this.cube, line)
        } else {
          if (this.cubes) this.cubes.add(this.cube)
        }
        this.camera.position.set(0, 0, this.maxSize * 2 * (this.isDesktop ? 1.05 : 1.5))
        cb && cb()
      }
      this.initHelper()
      if (this.controls) this.controls.enableRotate = this.interact
      if (this.controls) this.controls.autoRotate = this.autoRotate
      if (this.dragControls) this.dragControls.enabled = !this.interact
    },
    draw(canvas, cb, useCachedChunks = true) {
      this.GRIDY.setFile(this.work)
      if (!this.realVoxel) {
        if (this.initThree) {
          this.drawIt(canvas, cb, useCachedChunks)
          return
        }
        this.initThree = true
        if (!this.group) this.group = new THREE.Group()
        this.scene.add(this.group)
        if (!this.diy) this.diy = new THREE.Group()
        this.diy.position.set(0, 1.5 + this.fixpos, 0)
        this.group.add(this.diy)
        if (!this.cubes) this.cubes = new THREE.Group()
        this.cubes.position.set(0, 3.5 + this.fixpos + (this.diyType === 'paper' ? -8 : (this.diyType === 'gridy' ? -4 : 0)), 0)
        this.group.add(this.cubes)
        this.drawIt(canvas, cb, useCachedChunks)
        return
      }
      // 体素模型（优化：InstancedMesh渲染）
      const cubeSize = 1.0
      const cols = this.work.canvas.cols
      const rows = this.work.canvas.rows
      const sceneData = this.GRIDY.getSceneData(0)
      const data = sceneData.imageData
      // 统计不同颜色
      const colorMap = {}
      for (let i = 0; i < data.length; i++) {
        if (data[i]) {
          const color = data[i].replace('#', '0x')
          if (!colorMap[color]) colorMap[color] = []
          colorMap[color].push(i)
        }
      }
      // 清理旧mesh
      if (this.mergeMesh) {
        this.scene.remove(this.mergeMesh)
        this.mergeMesh.traverse(obj => {
          if (obj.isMesh) {
            obj.geometry.dispose()
            obj.material.dispose()
          }
        })
        this.mergeMesh = null
      }
      this.mergeMesh = new THREE.Group()
      Object.keys(colorMap).forEach(color => {
        const indices = colorMap[color]
        const geometry = new THREE.BoxGeometry(cubeSize, cubeSize, cubeSize)
        const material = new THREE.MeshStandardMaterial({ color: parseInt(color) })
        const mesh = new THREE.InstancedMesh(geometry, material, indices.length)
        let idx = 0
        indices.forEach(i => {
          const y = Math.floor(i / cols)
          const x = i - y * cols
          const pos = [x - Math.round(cols / 2), -y + Math.round(rows / 2), 0]
          const matrix = new THREE.Matrix4().makeTranslation(...pos)
          mesh.setMatrixAt(idx++, matrix)
        })
        mesh.instanceMatrix.needsUpdate = true
        this.mergeMesh.add(mesh)
      })
      this.scene.add(this.mergeMesh)
      // 相机位置适配
      this.camera.position.set(0, 0, Math.max(cols, rows) * 2 * (this.isDesktop ? 1.05 : 1.5))
      cb && cb()
    },
    launch(cb) {
      if (this.inited) {
        cb && cb()
      } else {
        this.init(cb)
        this.animate()
      }
    },
    init(cb, count) {
      count = count || 0
      if (count > 10) return
      this.container = this.$refs.voxelViewerDiv
      if (!this.container) {
        setTimeout(() => {
          count++
          this.init(cb, count)
        }, 100)
        return
      }
      this.boxEl = this.getBox('voxelViewerDiv')
      this.initRender()
      this.initScene()
      this.initSkybox()
      this.initHelper()
      this.initCamera()
      this.initLight()
      this.initControls()
      this.animate()
      this.inited = true
      window.onresize = this.onResize
      cb && cb()
    },
    initRender() {
      this.renderer = new THREE.WebGLRenderer({ antialias: true, powerPreference: 'high-performance' })
      this.renderer.setClearColor(this.bgColor)
      // 限制像素比，降低超高DPR设备的负载
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.75))
      this.renderer.setSize(this.boxEl.width, this.boxEl.height)
      // 关闭阴影以提升性能（场景中未明显使用阴影）
      this.renderer.shadowMap.enabled = false
      this.renderer.domElement.id = 'voxelCanvas'
      this.container.appendChild(this.renderer.domElement)
    },
    initCamera() {
      this.camera = new THREE.PerspectiveCamera(45, this.boxEl.width / this.boxEl.height, 0.1, 1000)
      this.camera.position.set(0, 10, this.maxSize * 3)
      this.camera.lookAt(new THREE.Vector3(0, 0, 0))
      this.scene.add(this.camera)
    },
    initLight() {
      // 清理旧光源
      if (this.light) {
        this.scene.remove(this.light)
        this.light = null
      }
      // 亮度缩放：将 0-100 转换到一个合理的强度范围
      const lv = Math.max(0, Math.min(100, this.lightValue))
      const scale = lv / 50 // 50 为基准值，>50 更亮，<50 更暗

      // 环境光（保存引用，便于动态调整）
      this.ambientLight = new THREE.AmbientLight(0xffffff, 0.5 * scale)
      const ambient = this.ambientLight
      this.scene.add(ambient)
      // 平行光
      this.dirLight = new THREE.DirectionalLight(0xffffff, 1 * scale)
      const dirLight = this.dirLight
      // 根据 lightAngel（方位角）与 lightElevation（仰角）设置平行光位置
      const radius = 40
      const az = (this.lightAngel % 360) * Math.PI / 180
      const el = Math.max(0, Math.min(90, this.lightElevation)) * Math.PI / 180
      const x = Math.cos(el) * Math.cos(az) * radius
      const y = Math.sin(el) * radius
      const z = Math.cos(el) * Math.sin(az) * radius
      dirLight.position.set(x, y, z)
      // 让灯光照向场景中心
      dirLight.target = new THREE.Object3D()
      dirLight.target.position.set(0, 0, 0)
      this.scene.add(dirLight.target)
      // 关闭阴影计算，进一步减少GPU/CPU开销
      dirLight.castShadow = false
      this.scene.add(dirLight)
      this.light = dirLight
    },
    initScene() {
      this.scene = new THREE.Scene()
    },
    // 设置灯光亮度（0-100），动态更新
    setLightValue(v) {
      const nv = Math.max(0, Math.min(100, Number(v)))
      this.lightValue = nv
      const scale = nv / 50
      if (this.ambientLight) this.ambientLight.intensity = 0.5 * scale
      if (this.dirLight) this.dirLight.intensity = 1 * scale
      this.render()
    },
    // 设置灯光照射角度（0-360，绕Y轴旋转）
    setLightAngel(angle) {
      const a = Math.max(0, Math.min(360, Number(angle)))
      this.lightAngel = a
      if (this.dirLight) {
        const radius = 40
        const az = (a % 360) * Math.PI / 180
        const el = Math.max(0, Math.min(90, this.lightElevation)) * Math.PI / 180
        const x = Math.cos(el) * Math.cos(az) * radius
        const y = Math.sin(el) * radius
        const z = Math.cos(el) * Math.sin(az) * radius
        this.dirLight.position.set(x, y, z)
        this.dirLight.updateMatrixWorld()
      }
      this.render()
    },
    // 设置灯光仰角（0-90 度）
    setLightElevation(elv) {
      const e = Math.max(0, Math.min(90, Number(elv)))
      this.lightElevation = e
      if (this.dirLight) {
        const radius = 40
        const az = (this.lightAngel % 360) * Math.PI / 180
        const el = e * Math.PI / 180
        const x = Math.cos(el) * Math.cos(az) * radius
        const y = Math.sin(el) * radius
        const z = Math.cos(el) * Math.sin(az) * radius
        this.dirLight.position.set(x, y, z)
        this.dirLight.updateMatrixWorld()
      }
      this.render()
    },
    // 纹理开关
    textureToggle(textureShow) {
      this.textureShow = typeof textureShow !== 'undefined' ? textureShow : !this.textureShow
      this.setLightValue(this.textureShow ? this.lightValueMax : this.lightValueMin)
      const enable = this.textureShow
      const root = this.currentModel
      if (!root) {
        this.render()
        return
      }
      root.traverse((obj) => {
        if (!obj || !obj.isMesh) return
        // 使用不受光照影响的白色材质以获得纯白效果
        if (enable) {
          // 恢复原材质
          if (obj.userData && obj.userData._origMaterial) {
            // 释放临时白色材质资源
            const disposeMat = (m) => {
              if (!m) return
              if (Array.isArray(m)) { m.forEach(disposeMat); return }
              if (m.dispose) m.dispose()
            }
            disposeMat(obj.material)
            obj.material = obj.userData._origMaterial
            delete obj.userData._origMaterial
            obj.material.needsUpdate = true
          }
        } else {
          // 切换到纯白材质，并保存原材质
          if (!obj.userData) obj.userData = {}
          if (!obj.userData._origMaterial) {
            obj.userData._origMaterial = obj.material
          }
          const makeWhite = (srcMat) => {
            const baseParams = { color: 0xffffff, flatShading: true }
            if (srcMat && typeof srcMat.side !== 'undefined') baseParams.side = srcMat.side
            // 使用受光材质以保留明暗关系
            return new THREE.MeshLambertMaterial(baseParams)
          }
          if (Array.isArray(obj.userData._origMaterial)) {
            obj.material = obj.userData._origMaterial.map((m) => makeWhite(m))
          } else {
            obj.material = makeWhite(obj.userData._origMaterial)
          }
          obj.material.needsUpdate = true
        }
      })
      this.render()
    },
    // 反照率模式开关：显示模型原始颜色，不受光照影响
    setAlbedo(enabled) {
      this.albedo = typeof enabled !== 'undefined' ? enabled : !this.albedo
      // 反照率模式只在d3模式下生效
      if (this.diyType !== 'd3') {
        this.render()
        return
      }
      const root = this.currentModel
      if (!root) {
        this.render()
        return
      }
      root.traverse((obj) => {
        if (!obj || !obj.isMesh) return
        if (this.albedo) {
          // 启用反照率模式：切换到不受光照影响的基础材质，保留原始颜色
          if (!obj.userData) obj.userData = {}
          if (!obj.userData._origMaterial) {
            obj.userData._origMaterial = obj.material
          }
          const makeAlbedoMaterial = (srcMat) => {
            const baseParams = {}
            // 保留原始颜色
            if (srcMat.vertexColors) {
              baseParams.vertexColors = true
            } else if (srcMat.color) {
              baseParams.color = srcMat.color.clone ? srcMat.color.clone() : srcMat.color
            } else {
              // 如果没有指定颜色，使用白色作为默认值
              baseParams.color = 0xffffff
            }
            // 保留其他属性
            if (srcMat.side !== undefined) baseParams.side = srcMat.side
            if (srcMat.transparent !== undefined) baseParams.transparent = srcMat.transparent
            if (srcMat.opacity !== undefined) baseParams.opacity = srcMat.opacity
            if (srcMat.map) baseParams.map = srcMat.map
            // 使用 MeshBasicMaterial 不受光照影响，直接显示原始颜色
            // MeshBasicMaterial 会自动支持 vertexColors 和 instanceColor
            return new THREE.MeshBasicMaterial(baseParams)
          }
          if (Array.isArray(obj.userData._origMaterial)) {
            obj.material = obj.userData._origMaterial.map((m) => makeAlbedoMaterial(m))
          } else {
            obj.material = makeAlbedoMaterial(obj.userData._origMaterial)
          }
          obj.material.needsUpdate = true
        } else {
          // 禁用反照率模式：恢复原材质
          if (obj.userData && obj.userData._origMaterial) {
            const disposeMat = (m) => {
              if (!m) return
              if (Array.isArray(m)) { m.forEach(disposeMat); return }
              if (m.dispose) m.dispose()
            }
            disposeMat(obj.material)
            obj.material = obj.userData._origMaterial
            delete obj.userData._origMaterial
            obj.material.needsUpdate = true
          }
        }
      })
      this.render()
    },
    initSkybox() {
      this.skyGeometry = new THREE.BoxGeometry(4096,4096,4096)
      this.textureCube = new THREE.CubeTextureLoader().load(this.skyBoxTextures[this.skyStyleid || this.skyBoxTextureIdx])
      this.shader = THREE.ShaderLib.cube
      this.shader.uniforms.tCube.value = this.textureCube
      this.skyMaterial = new THREE.ShaderMaterial({
        fragmentShader: this.shader.fragmentShader,
        vertexShader: this.shader.vertexShader,
        uniforms: this.shader.uniforms,
        depthWrite: false,
        blending: THREE.NoBlending,
        side: THREE.BackSide
      })
      this.skybox = new THREE.Mesh(this.skyGeometry,this.skyMaterial)
      this.skybox.name = "skybox"
      // 天空盒不需要参与视锥裁剪和矩阵更新
      this.skybox.frustumCulled = false
      this.skybox.matrixAutoUpdate = false
      this.scene.add(this.skybox)
    },
    initHelper() {
      if (this.gridHelper) this.scene.remove(this.gridHelper)
      if (!this.interact || !this.showHelper) return
      this.gridHelper = new THREE.GridHelper(this.maxSize, Math.round(this.maxSize / 2), 0x333333, 0x333333)
      this.gridHelper.position.y = Math.round(-this.rows / 2) - 5
      this.scene.add(this.gridHelper)
    },
    initControls() {
      this.controls = new OrbitControls(this.camera, this.renderer.domElement)
      this.dragControls = new DragControls([this.group], this.camera, this.renderer.domElement)
      // 交互模式下，不可拖拽
      this.dragControls.enabled = !this.interact
      // 仅在参数变化时渲染
      this.controls.addEventListener('change', this.render)
      // 禁止旋转
      this.controls.enableRotate = this.interact
      // 使动画循环使用时阻尼或自转 意思是否有惯性
      this.controls.enableDamping = true
      // 动态阻尼系数 就是鼠标拖拽旋转灵敏度
      this.controls.dampingFactor = 0.25
      // 是否可以缩放
      this.controls.enableZoom = true
      // 缩放范围
      this.controls.minZoom = 0.1
      this.controls.maxZoom = 300
      // 是否自动旋转
      this.controls.autoRotate = this.autoRotate
      this.controls.autoRotateSpeed = this.autoRotateSpeed
      // 设置相机距离原点的最近距离
      this.controls.minDistance = 10
      // 设置相机距离原点的最远距离
      this.controls.maxDistance = 2000
      // 是否开启右键拖拽
      this.controls.enablePan = true
      // 限制只能上下旋转
      // this.controls.minPolarAngle = 0
      // this.controls.maxPolarAngle = Math.PI
      // 限制只能左右旋转
      // this.controls.minPolarAngle = Math.PI / 2
      // this.controls.maxPolarAngle = Math.PI / 2
    },
    render() {
      if (this.renderer) this.renderer.render(this.scene, this.camera)
    },
    onResize() {
      this.box = this.getBox('voxelViewerDiv')
      this.camera.aspect = this.boxEl.width / this.boxEl.height
      this.camera.updateProjectionMatrix()
      this.render()
      this.renderer.setSize(this.boxEl.width, this.boxEl.height)
    },
    animate() {
      this.render()
      if (this.controls) this.controls.update()
      requestAnimationFrame(this.animate)
    },
    exportScenes(binary, cb) {
      this.exportGLTF([this.realVoxel ? this.mergeMesh : this.cubes], binary, cb)
    },
    initCubesPos() {
      if (this.cubes) this.cubes.position.set(0, 3.5 + this.fixpos + (this.diyType === 'paper' ? -8 : (this.diyType === 'gridy' ? -4 : 0)), 0)
    },
    zoomIn() {
      const minY = this.isDesktop? -8 : 0
      this.initCubesPos()
      const pos = this.cubes.position
      const position = this.camera.position
      position.x = 0
      position.y = 0
      const minZ = position.z / 2.5
      let n = 0
      let factor = 1
      const run = (z) => {
        if (z > minZ) {
          setTimeout(() => {
            position.z = z - factor
            if (pos.y > minY) pos.y = pos.y - 1
            n++
            if (n > minZ / 2 ) {
              factor = 2
            } else if (n > minZ) {
              factor = 3
            }
            this.camera.lookAt(position)
            run(position.z)
          }, 1)
        }
      }
      run(position.z)
    },
    exportGLTF(input, binary, cb) {
      if (typeof binary === 'undefined') binary = true
      const gltfExporter = new GLTFExporter()
      const options = {
        trs: false,
        onlyVisible: true,
        binary: binary,
        maxTextureSize: 4096
      }
      gltfExporter.parse(
        input,
        (result) => {
          if (result instanceof ArrayBuffer) {
            this.saveArrayBuffer(result, cb)
          } else {
            const output = JSON.stringify(result, null, 2)
            this.saveString(output, cb)
          }
        },
        function(error) {
          console.error('An error happened during gltfExporter parsing', error)
        },
        options
      )
    },
    saveString(text, cb) {
      const filename = (this.work.name || 'Untitle') + '-GridyArt_' + utils.date('str') + '.gltf'
      download(new Blob([text], { type: 'text/plain' }), filename, 'text/plain')
      cb && cb(this.work.workid, 'gltf')
    },
    saveArrayBuffer(buffer, cb) {
      const filename = (this.work.name || 'Untitle') + '-GridyArt_' + utils.date('str') + '.glb'
      download(new Blob([buffer], { type: 'text/plain' }), filename, 'application/octet-stream')
      cb && cb(this.work.workid, 'glb')
    }
  }
}
</script>
